import React from "react"
import Select from "react-select"
import AsyncSelect from "react-select/async"
import PropTypes from "prop-types"

export default function SelectBox(props) {
  const {
    value,
    name,
    onChange,
    label,
    placeholder,
    options,
    isDisabled,
    isMulti,
    className,
    defaultValue,
    inputRef,
    isAsync,
    loadOptions,
  } = props
  function handleChange(event) {
    // Overwrite the event with your own object if it doesn't exist
    if (!event) {
      event = {
        target: inputRef,
        value: "",
      }
    }
    onChange(event)
  }

  const styles = {
    // ...other styles...
    valueContainer: css => ({
      ...css,
      width: "200px",
      "flex-wrap": "nowrap",
      "white-space": "nowrap",
      overflow: "hidden",
      "text-overflow": "ellipsis",
    }),
  }

  return (
    <>
      {label && <label className="control-label">{label}</label>}
      {isAsync ? (
        <AsyncSelect
          ref={inputRef}
          className={`select2-selection ${className}`}
          value={value}
          defaultValue={defaultValue}
          onChange={onChange}
          // cacheOptions
          defaultOptions
          name={name}
          loadOptions={loadOptions}
          isDisabled={isDisabled}
          placeholder={placeholder}
          isClearable
          {...props}
          styles={styles}
          menuposition="fixed"
        />
      ) : (
        <Select
          ref={inputRef}
          onChange={handleChange}
          className={`select2-selection ${className}`}
          menuPortalTarget={document.body}
          menuPosition={"fixed"}
          placeholder={placeholder}
          name={name}
          value={value}
          defaultValue={defaultValue}
          isMulti={isMulti}
          options={options}
          isDisabled={isDisabled}
          isClearable
          {...props}
          styles={styles}
        />
      )}
    </>
  )
}

SelectBox.defaultProps = {
  label: "",
  value: {},
  onChange: null,
  placeholder: "",
  isDisabled: false,
  isMulti: false,
  options: [],
}

SelectBox.propTypes = {
  placeholder: PropTypes.string,
  options: PropTypes.array,
  label: PropTypes.string,
  isDisabled: PropTypes.bool,
  isMulti: PropTypes.bool,
  onChange: PropTypes.func,
}
